import React from 'react';
import { Box, Paper, Typography, Button, Stack } from '@mui/material';

const SubscriptionModal = ({ 
  open, 
  onClose, 
  onSubscribe,
  featureRequested = "feature"
}) => {
  if (!open) return null;

  return (
    <Box sx={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      zIndex: 9999,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      <Paper sx={{ padding: 3, maxWidth: 300, textAlign: 'center' }}>
        <Typography variant="h6" gutterBottom>
          Subscription Required
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Please subscribe to use the {featureRequested} feature.
        </Typography>
        <Stack direction="row" spacing={2} justifyContent="center">
          <Button 
            variant="outlined" 
            color="secondary" 
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button 
            variant="contained" 
            color="primary"
            onClick={onSubscribe}
          >
            Subscribe
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
};

export default SubscriptionModal;
